import React, { useState } from 'react';
import { ProfileDropdown } from '@/components/ProfileDropdown';
import { ProfileStatusBanner } from '@/components/ProfileStatusBanner';
import { Layout } from '@/layouts/Layout';
import { Attendance } from '@/pages/Overview/Attendance';
import { Journals } from '@/pages/Overview/Journals';
import { Ratings } from '@/pages/Overview/Ratings';
import { Report } from '@/pages/Overview/Report';
import { OverviewTab } from '@/types/components';
import { OverviewTabs } from '@/pages/Overview/OverviewTabs';

export const Overview: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(OverviewTab.Ratings);
  const [isJournalOpen, setIsJournalOpen] = useState(false);
  const tabs = <OverviewTabs value={selectedTab} onChange={setSelectedTab} />;
  const mobileHeader = (
    <div className="flex w-full flex-col gap-7">
      <ProfileDropdown />
      {tabs}
    </div>
  );
  return (
    <Layout
      desktopHeader={tabs}
      mobileHeader={mobileHeader}
      hideMobileHeader={isJournalOpen}
      hideMobileNavbar={isJournalOpen}
    >
      {!isJournalOpen && <ProfileStatusBanner />}
      {selectedTab === OverviewTab.Ratings && <Ratings />}
      {selectedTab === OverviewTab.Journals && (
        <Journals onOpenChange={setIsJournalOpen} />
      )}
      {selectedTab === OverviewTab.Attendance && <Attendance />}
      {selectedTab === OverviewTab.Report && <Report />}
    </Layout>
  );
};
